﻿import ko from 'knockout';
import { httpClient } from './httpClient';
import { Log } from './log';

class JoinWithRoomKeyModel {
	public roomKeyPartial = ko.observable<string>('');
	public inputIsInvalid = ko.pureComputed(
		() => this.roomKeyPartial().length !== 4,
	);
	public hasError = ko.observable<boolean>(false);
	public errorMessage = ko.observable<string>('');

	constructor() {}

	public joinMeeting() {
		if (this.inputIsInvalid()) return;

		httpClient
			.get(`/api/meetings/join/room-key/${this.roomKeyPartial()}`)
			.then((videoRoomKey) => {
				window.location.href = `/room/${videoRoomKey}`;
			})
			.catch((error) => {
				const errorMsg = error.data;

				if (error.status !== 404) {
					Log.error(
						'Unsuspected error when trying to join meeting with room key partial. ' +
							error.status +
							': ' +
							errorMsg,
					);
				}

				this.hasError(true);
				this.errorMessage(errorMsg ?? 'Der gik noget galt');
			});
	}
}

export function JoinWithRoomKey(): void {
	ko.applyBindings(new JoinWithRoomKeyModel(), document.body);
}
